import { render, staticRenderFns } from "./limitesNorma.vue?vue&type=template&id=3a0e219b"
import script from "./limitesNorma.vue?vue&type=script&lang=js"
export * from "./limitesNorma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports